<template>
  <div id="app">
    <nav class="navbar navbar-default" style="height: 64px; margin-bottom: 0">
      <div class="container-fluid">
        <div class="navbar-header" style="width: 100%;">
          <a class="navbar-brand" href="https://gruponc.bitbucket.io/"><img src="./assets/gruponc_0.png" style="max-width: 180px;
    margin-right: 1rem; "></a>
          <img src="./assets/logo_NC_Digital-04.png" style=" max-width: 63px; margin-right: 1rem; float: right;">
        </div>

      </div>
    </nav>
    <div style="background-color:#0f495c;color:#fff;height: 150px;display:table;text-align: center;width:100%;">
    <span style="color:white;display:table-cell;vertical-align:middle;font-size:28px">Fair Market Value</span>
    </div>

    <router-view class="view"></router-view>
  </div>

  
</template>

<script>
import Vue from "vue";
import VueRouter from "vue-router";

import "bootstrap/dist/css/bootstrap.css";

Vue.use(VueRouter);

const Survey = () =>
  import(/* webpackChunkName: "survey" */ "./views/Survey.vue");


const router = new VueRouter({
  mode: "history",
  base: __dirname,
  routes: [
    { path: "/", component: Survey },
    // Just use them normally in the route config
    // multiple parameters, `/` should not be encoded. The name is also important
    // https://github.com/vuejs/vue-router/issues/2719
    // { path: '/a/:tags*', name: 'tagged', component: () => new Promise(resolve => {
    //   setTimeout(() => {
    //     resolve({
    //       template: `<div>
    //         <h2>Lazy with params</h2>
    //         <pre id="tagged-path">{{ $route.path }}</pre>
    //       </div>`
    //     })
    //   }, 200)
    // }) },
    // Bar and Baz belong to the same root route
    // and grouped in the same async chunk.
  ]
});

export default {
  name: "app",
  router: router,
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
</style>
